import React from 'react'
import Informations from './Informations'

const DisponibilityItem = ({ item }) => {
    const cardStyle = {
        background: '#ffffff',
        padding: '0.7rem',
        borderRadius: '3px',
        borderTop: '2px solid #05a548',
        boxShadow: '0px 5px 15px 1px #e4e4e4'
    }
    const nameStyle = {
        fontSize: '17px',
        color: '#323232',
        fontWeight: 500,
        marginBottom: '.4rem'
    }

    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-h">
            <div style={cardStyle}>
                <div style={nameStyle}>
                    <span>{item.title}</span>
                </div>
                <div>
                    <Informations items={item.description} />
                </div>
            </div>
        </div>
    )
}

export default DisponibilityItem